import { render, staticRenderFns } from "./fitbEditor.vue?vue&type=template&id=05af7076&"
import script from "./fitbEditor.vue?vue&type=script&lang=js&"
export * from "./fitbEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports